import { SvgIconComponent } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';

type Props = {
  Icon: SvgIconComponent;
  onClick: () => void;
  tooltip: string;
  color?: 'secondary' | 'error' | 'success';
  disabled?: boolean;
};

export const BatchActionButton: React.FC<Props> = ({
  Icon,
  color,
  onClick,
  disabled,
  tooltip,
}) => (
  <Tooltip title={tooltip}>
    <IconButton {...(!disabled && { onClick })}>
      <Icon {...(!disabled && { color })} />
    </IconButton>
  </Tooltip>
);
